export default __webpack_public_path__ + "static/media/flask.fac00338.jpg";